const themeModeReducer = (state = "dark", action) => {
    switch (action.type) {
      case "SET_THEME_MODE":
        return action.payload;
      default:
        return state;
    }
  }
  export default themeModeReducer;